// src/components/Auth/WelcomeBackScreen.tsx
import React from 'react';
import { motion } from 'framer-motion';
import { LogIn, LogOut } from 'lucide-react';

interface WelcomeBackScreenProps {
  email?: string;
  name?: string;
  onLogin: () => void;
  onLogout: () => void;
  onContinue?: () => void; // Add onContinue prop
}

export function WelcomeBackScreen({ 
  email, 
  name,
  onLogin,
  onLogout,
  onContinue  // New prop for continuing to app
}: WelcomeBackScreenProps) {
  // Get display name - use first part of email if name isn't available
  const displayName = name || (email ? email.split('@')[0] : 'there');
  
  // Use onContinue if provided, otherwise fallback to onLogin
  const handleContinue = () => {
    if (onContinue) {
      onContinue();
    } else {
      onLogin();
    }
  };
  
  return (
    <>
      {/* Header */}
      <div className="px-6 flex flex-col justify-center border-b border-gray-200" style={{ height: '90px' }}>
         <h2 className="text-gray-900" style={{
          fontSize: 'var(--auth-font-size-2xl)',
          fontWeight: 'var(--auth-font-weight-regular)',
          fontFamily: 'var(--auth-header-font-family)'
        }}>Welcome Back</h2>
        {/* <p className="text-sm text-gray-500 mt-1">
          Sign in to continue to Tripper
        </p> */}
      </div>
      {/* <div className="px-6 py-4 border-b border-gray-200">
        <h2 className="text-lg font-semibold text-gray-900">Welcome Back</h2>
        <p className="text-sm text-gray-500 mt-1">
          Sign in to continue to Tripper
        </p>
      </div> */}

      {/* Content */}
      <div className="p-6 flex flex-col items-center">
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.3 }}
          className="w-20 h-20 rounded-full bg-blue-100 flex items-center justify-center mb-4"
        >
          <span className="text-3xl">✈️</span>
        </motion.div>

        <p className="text-r font-regular text-center mb-6 py-4">
          Ready to continue your travel adventures?
          {/* Welcome back, {displayName}! */}
        </p>
        
        {/* {email && (
          <p className="text-gray-500 text-sm text-center mb-6">
            {email}
          </p>
        )} */}
       {/*  <p className="text-gray-600 text-center mb-8">
          Ready to continue your travel adventures?
        </p> */}

        <div className="w-full" style={{ display: 'flex', flexDirection: 'column', gap: 'var(--auth-button-gap)' }}>
          <button
            onClick={handleContinue}
            className="w-full bg-blue-600 text-white hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
            style={{
              height: 'var(--auth-button-height)',
              padding: 'var(--auth-button-padding)',
              fontSize: 'var(--auth-button-font-size)',
              fontWeight: 'var(--auth-button-font-weight)',
              borderRadius: 'var(--auth-button-border-radius)'
            }}
          >
            <LogIn style={{ width: 'var(--auth-button-icon-size)', height: 'var(--auth-button-icon-size)' }} />
            <span>Continue to Tripper</span>
          </button>
          
          <button
            onClick={onLogout}
            className="w-full border border-gray-300 hover:bg-gray-50 transition-colors flex items-center justify-center gap-2"
            style={{
              height: 'var(--auth-button-height)',
              padding: 'var(--auth-button-padding)',
              fontSize: 'var(--auth-button-font-size)',
              fontWeight: 'var(--auth-button-font-weight)',
              borderRadius: 'var(--auth-button-border-radius)'
            }}
          >
            <LogOut style={{ width: 'var(--auth-button-icon-size)', height: 'var(--auth-button-icon-size)' }} />
            <span>Use a Different Account</span>
          </button>
        </div>
        <div className="mt-6 text-xs text-gray-500 text-center">
          <p>
            By continuing, you agree to our <a href="/terms-of-use" className="text-blue-600 hover:underline">Terms of Use</a> and <a href="/privacy-policy" className="text-blue-600 hover:underline">Privacy Policy</a>.
          </p>
        </div>
      </div>
    </>
  );
}